import { render, staticRenderFns } from "./AppointmentPreview.vue?vue&type=template&id=4fa6ff03&"
import script from "./AppointmentPreview.vue?vue&type=script&lang=js&"
export * from "./AppointmentPreview.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentPreview.vue?vue&type=style&index=0&id=4fa6ff03&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports